import {
  getRadioUtilityClass,
  Radio as MuiRadio,
  RadioGroup as MuiRadioGroup,
  useThemeProps,
} from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { radioClasses } from './constants';
import { CustomRadioProps, RadioProps } from './types';

export const RadioGroup = MuiRadioGroup;

function RadioIconContainer(props: React.PropsWithChildren) {
  return (
    <div
      className={radioClasses.iconContainer}
      {...props}
    />
  );
}

function RadioIconDot() {
  return <div className={radioClasses.dot} />;
}

export const Radio = React.forwardRef<HTMLButtonElement, RadioProps>(
  (inProps: RadioProps, ref: React.RefObject<HTMLButtonElement>) => {
    const props: RadioProps & Required<CustomRadioProps> = useThemeProps({
      props: {
        size: 'medium',
        ...inProps,
      },
      name: 'MuiRadio',
    });

    const { size = 'medium', className, ...rest } = props;

    return (
      <MuiRadio
        ref={ref}
        icon={(
          <RadioIconContainer>
            <RadioIconDot />
          </RadioIconContainer>
        )}
        checkedIcon={(
          <RadioIconContainer>
            <RadioIconDot />
          </RadioIconContainer>
        )}
        className={clsx(className, getRadioUtilityClass(size))}
        size={size}
        {...rest}
      />
    );
  },
);
Radio.displayName = 'Radio';
